module.exports = __webpack_public_path__ + "static/img/equip@2x.66af99a4.png";